import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showToast } from '@/services/toast-service';
import { setBroadcastMessageToActive } from '@/services/coloc-api/admin';
import { usePopUpConfirmation } from '@/features/shared/pop-up-confirmation/hooks';

export const useSetToActiveBroadcastMessage = () => {
  const queryClient = useQueryClient();
  const { openPopUpConfirmation } = usePopUpConfirmation();

  const mutation = useMutation({
    mutationKey: ['setToActiveBroadcastMessage'],
    mutationFn: (id: number) => setBroadcastMessageToActive(id),
    onSuccess: () => {
      queryClient.invalidateQueries(['broadcast-messages']);
      openPopUpConfirmation({
        type: 'feedback',
        title: 'Message activated',
        confirmLabel: 'Done',
      });
    },
    onError: () => {
      showToast.error({
        title: 'Failed to activate message',
        text: 'Please try again.',
      });
    },
  });

  return {
    setToActive: mutation.mutate,
    isLoading: mutation.isLoading,
    error: mutation.error,
  };
};
